import { FormikContextType } from "formik";
import { useMemo } from "react";
import { useCurrentOrganizationMembers } from "@api/organizationMember.api";
import { VStack } from "@design-system/VStack/VStack";
import type { ApplyCloseTemplateWizardValues } from "./applyCloseTemplate.schema";
import { MemberCombobox } from "./MemberCombobox";
import { getMemberLabel } from "./serviceTemplateScheduleMemberLabel";

interface Props {
    formik: FormikContextType<ApplyCloseTemplateWizardValues>;
}

export const ScheduleTemplateStepTeam = ({ formik }: Props) => {
    const { data: orgMembers = [] } = useCurrentOrganizationMembers();

    const getMemberLabelFn = useMemo(
        () => (id: number | null) => {
            if (id === null) {
                return "";
            }
            const member = orgMembers.find((m) => m.user.id === id);
            return member ? getMemberLabel(member) : String(id);
        },
        [orgMembers],
    );

    return (
        <VStack gap={16}>
            <MemberCombobox
                label="Preparer"
                value={formik.values.defaults.preparerId ?? null}
                members={orgMembers}
                getMemberLabel={getMemberLabelFn}
                onValueChange={(v) =>
                    void formik.setFieldValue("defaults.preparerId", v)
                }
            />

            <MemberCombobox
                label="Reviewer"
                value={formik.values.defaults.reviewerId ?? null}
                members={orgMembers}
                getMemberLabel={getMemberLabelFn}
                onValueChange={(v) =>
                    void formik.setFieldValue("defaults.reviewerId", v)
                }
            />

            <MemberCombobox
                label="Manager"
                value={formik.values.defaults.managerId ?? null}
                members={orgMembers}
                getMemberLabel={getMemberLabelFn}
                onValueChange={(v) =>
                    void formik.setFieldValue("defaults.managerId", v)
                }
            />
        </VStack>
    );
};
